<template>
  <div class="c-signature">
    <h1 class="c-users-information__title">{{ $t('usersInformation.signature.title') }}</h1>
    <p class="c-users-information__text">{{ $t('usersInformation.signature.text') }}</p>
    <!-- row-1 -->
    <div class="form-row">
      <quillEditor class="quill-editor" ref="signatureEditor" :value="signature" @change="onEditorChange($event)" :options="editorOption"></quillEditor>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: { quillEditor },
  props: {
    signature: {
      type: String
    },
    signatureQuillDelta: {
      type: String
    },
    IsAutoGenerateSignature: {
      type: Boolean
    }
  },
  data () {
    return {
      editorOption: {
        placeholder: '',
        modules: {
          toolbar: [
            [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
            ['bold', 'italic', 'underline']
          ]
        }
      }
    }
  },
  mounted () {
    // Add autofocus attribute to autofocus automatically
    let editor = document.querySelector(
      '.ql-editor'
    )
    editor.setAttribute('autofocus', 'autofocus')
    if (this.IsAutoGenerateSignature) {
      this.$refs.signatureEditor.quill.disable()
    }
  },
  computed: {
    editor () {
      return this.$refs.signatureEditor.quill
    }
  },
  methods: {
    onEditorChange ({html, text, quill}) {
      let quillDelta = JSON.stringify(quill.editor.delta)
      this.$emit('update:signature', html)
      this.$emit('update:signatureQuillDelta', quillDelta)
    }
  }
}
</script>

<style lang="scss">
.quill-editor {
  em {
    color:black
    }
}
</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/signature.vue